module.exports = __webpack_public_path__ + "img/brandme-talent.a076695a.png";